import instance from "api/axiosInstance";
import { isMobile } from "helpers/isMobile";
import { useState } from "react";
import { useNotification } from "./useNotification";

export const getPdfProxyUrl = (spacesUrl: string): string => {
  // Extract file key from URL - it might already be encoded or have spaces
  const parts = spacesUrl.split("digitaloceanspaces.com/");
  if (parts.length < 2) {
    return `/image/pdf-proxy?file=${encodeURIComponent(spacesUrl)}`;
  }

  // Presigned URLs carry a query string that is not part of the object key
  const rawFileKey = parts[1].split("?")[0];

  // Decode it first to handle cases where it's already encoded
  const decodedFileKey = decodeURIComponent(rawFileKey);

  // Then encode it properly for the query parameter
  return `/image/pdf-proxy?file=${encodeURIComponent(decodedFileKey)}`;
};

export const usePreviewPdf = () => {
  const [isLoading, setIsLoading] = useState(false);
  const [currentUrl, setCurrentUrl] = useState<string | null>(null);
  const { error } = useNotification();

  const previewPdf = (url: string) => {
    setIsLoading(true);
    setCurrentUrl(url);

    if (isMobile()) {
      instance
        .get(url, {
          responseType: "blob",
        })
        .then((response) => {
          setIsLoading(false);
          setCurrentUrl(null);
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement("a");
          link.href = url;
          link.setAttribute("download", "file.pdf");
          document.body.appendChild(link);
          link.click();
        })
        .catch(() => {
          setIsLoading(false);
          setCurrentUrl(null);
          error("Kunde inte öppna PDF-filen");
        });
    } else {
      instance
        .get(url, {
          responseType: "arraybuffer",
        })
        .then((response) => {
          setIsLoading(false);
          setCurrentUrl(null);
          const blob = new Blob([response.data], { type: "application/pdf" });
          const url = window.URL.createObjectURL(blob);
          window.open(url, "_blank");
        })
        .catch(() => {
          setIsLoading(false);
          setCurrentUrl(null);
          error("Kunde inte öppna PDF-filen");
        });
    }
  };
  return { previewPdf, isLoading, currentUrl };
};
